import { BaseModel } from "@blue-chip/core";
import ClientPricing from "./ClientPricing";

export default class PricingTier extends BaseModel {
  static get belongsTo() {
    return [ClientPricing];
  }
}
